<template>
  <div v-if="filteredList.length" class="suggestionMainWrapper">
    <span class="suggestionTitle">{{
      SCREEN_WIDTH < Breakpoints.sm
        ? $t('influencer.profile.slug.suggestion.suggestion00')
        : $t('influencer.profile.slug.suggestion.suggestion03')
    }}</span>
    <span class="suggestionSubtitle">
      {{
        $t('influencer.profile.slug.suggestion.suggestion01', {
          influencer: influencer.entity,
        })
      }}
    </span>
    <div class="cardWrap">
      <InfluencerCard
        v-for="inf in filteredList"
        :key="inf.id"
        class="influencerCard"
        :influencer="inf"
        @click="navInfProfile(inf)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import InfluencerCard from '~/components/influencer/card.vue'

import { useInfluencersStore } from '~/stores/influencers'
import { useMiscResizeStore } from '~/stores/miscResize'

import { Breakpoints } from '~/enums/breakpoints'

import type { Influencer, StatsV3Influencer } from '~/types/influencer'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    InfluencerCard,
  },
  props: {
    influencer: {
      type: Object as PropType<Influencer | StatsV3Influencer>,
      required: true,
    },
    suggested: {
      type: Array as PropType<Influencer['id'][]>,
      required: true,
    },
  },
  setup() {
    const localePath = useLocalePath()

    return {
      localePath,
    }
  },
  data() {
    return { Breakpoints }
  },
  computed: {
    ...mapState(useMiscResizeStore, ['SCREEN_WIDTH']),
    ...mapState(useInfluencersStore, { SUGGESTED_INFLUENCERS: 'list' }),
    filteredList(): StatsV3Influencer[] {
      return this.SUGGESTED_INFLUENCERS.filter(
        (e) => e.slug !== this.influencer.slug && this.suggested.includes(e.id),
      ).slice(0, 9)
    },
  },
  methods: {
    navInfProfile(influencer: StatsV3Influencer): void {
      this.$router.push(
        this.localePath(`/influencer/profile/${influencer.slug}/`),
      )
    },
  },
})
</script>

<style scoped lang="scss">
.influencerCard {
  @media screen and (min-width: 1024px) {
    grid-column: span 4;
  }

  @media screen and (min-width: 768px) {
    grid-column: span 6;
  }
}

.suggestionMainWrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  margin-bottom: 100px;

  @media screen and (min-width: 768px) {
    margin-top: 80px;
  }
}

.suggestionTitle {
  color: var(--color-black);
  font-size: var(--font-size-title);
  font-weight: 600;
  margin-bottom: 8px;
}

.suggestionSubtitle {
  color: var(--color-black);
  font-size: var(--font-size-big);
}

.cardWrap {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: var(--grid-gap);
  margin-top: 24px;

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(12, 1fr);
  }
  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(12, 1fr);
  }
}
</style>
